import * as deliveryActions from '../actions/delivery';
import * as fetchingState from '../constants/fetchingState';
import { deliveryErrors } from '../constants/deliveryErrors';

export default function(state, action) {
    switch (action.type) {
        case deliveryActions.FETCH_DELIVERY_CANCEL:
            {
                return {...state, cancelFetching: fetchingState.FETCHING, cancelError: null };
            }
        case deliveryActions.SUCCESS_DELIVERY_CANCEL:
            {
                if (action.data.error) {
                    const code = _getDeliveryErrorCode(action.data.error.Code);
                    const message = !action.data.error.Message ? '' : `: ${action.data.error.Message}`;
                    const errorMessage = `${code}${message}`;
                    return {...state, cancelFetching: fetchingState.FETCHED, cancelError: errorMessage };
                }
                return {...state, cancelFetching: fetchingState.FETCHED, cancelError: null };
            }
        case deliveryActions.FAILURE_DELIVERY_CANCEL:
            {
                return {...state, cancelFetching: fetchingState.FAILED, cancelError: _getDeliveryErrorCode('-100') };
            }
        default:
            return state;
    }

    function _getDeliveryErrorCode(code) {
        const error = deliveryErrors.find(a => a.Id === code);
        return error === undefined ? '' : error.Name;
    }
}


// WEBPACK FOOTER //
// ./src/reducers/deliveryReducer.js